import { OrgInfo } from '../../../../../../common/src/model.ts';
import { SyncAnimation } from '../../../../util/sync_animation.tsx';
import { HouseholdsList } from './households_list.tsx';
import { ResourcesPanel } from './resources_panel.tsx';
import { Heading, Panel, PanelContent, PanelTitle, Section, SectionContent, SectionTitle } from './shared.tsx';

export function HouseholdManagementSection({
  orgInfo,
  isDataRecentlySynced,
  updateOrgInfo,
}: {
  orgInfo?: OrgInfo;
  isDataRecentlySynced: boolean;
  updateOrgInfo: () => Promise<void>;
}) {
  const { householdInfo } = orgInfo ?? {};

  return (
    <Section>
      <Heading>
        <SectionTitle>Household Management</SectionTitle>
        {!isDataRecentlySynced && <SyncAnimation $size="25px" $marginLeft="15px" />}
      </Heading>
      <SectionContent>
        <Panel>
          <PanelTitle>Permissions</PanelTitle>
          <PanelContent>
            {householdInfo && (
              <HouseholdsList households={householdInfo.households} updateOrgInfo={updateOrgInfo} minWidth="25ch" />
            )}
          </PanelContent>
        </Panel>
        <ResourcesPanel orgInfo={orgInfo} />
      </SectionContent>
    </Section>
  );
}
